import { useEffect } from "react";
import "./loader.css";
import { CircularProgress } from "@mui/material";

export default function Loader({ loading }) {
  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);
  return (
    <>
      {loading && (
        <div className="loader-container">
          <CircularProgress color="inherit" />
        </div>
      )}
    </>
  );
}
